import React, { useState } from "react";
import { BaseModal } from "mcmap-lib/src/components/Modals/BaseModal";
import { useStore } from "mcmap-lib/src/stores/store";
import { ModalKeys } from "mcmap-lib/src/interfaces/config";
import { BlockedEmailForm } from "../Forms/BlockedEmailForm";
import { addOutReachEmail, getBlockedEmailList } from "../../utils/blockedEmails.utils";

const AddBlockedEmailModal = () => {
    const { isActive, deactivateTool, isAdminModalLoading, setBlockedEmails } = useStore();
    const [successAlertShown, setSuccessAlertShown] = useState(false);
    const [errorAlertShown, setErrorAlertShown] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [email, setEmail] = useState("");

    const resetEmail = () => {
        setEmail("");
    };

    const onClose = () => {
        resetEmail();
        deactivateTool(ModalKeys.ADD_BLOCKED_EMAIL);
    };

    const syncBlockedEmails = async () => {
        const blockedEmailsList: string[] = await getBlockedEmailList();
        setBlockedEmails(blockedEmailsList);
    };

    const onAddBlockedEmailClicked = async () => {
        try {
            const addBlockedEmail = await addOutReachEmail(email);
            if (!addBlockedEmail) {
                return
            }
            if (addBlockedEmail.success) {
                setSuccessMessage(addBlockedEmail.message);
                setSuccessAlertShown(true);
                setEmail("");
                setIsFormValid(false);
                syncBlockedEmails();
                setTimeout(() => {
                    setSuccessAlertShown(false);
                }, 5000);
                deactivateTool(ModalKeys.ADD_BLOCKED_EMAIL);
            } else {
                setErrorMessage(addBlockedEmail.message);
                setErrorAlertShown(true);
                setTimeout(() => {
                    setErrorAlertShown(false);
                }, 5000);
            }

        } catch (error) {
            if (error && error.message) {
                setErrorMessage(error.message);
            } else {
                setErrorMessage("An error occurred while adding the blocked email.");
            }
            setErrorAlertShown(true);
            setTimeout(() => {
                setErrorAlertShown(false);
            }, 5000);
        }
    }

    return (
        <>
            <BaseModal active={isActive(ModalKeys.ADD_BLOCKED_EMAIL)} title="Add Blocked Email">
                <div className="p-3 font-helvetica text-sm">
                    <BlockedEmailForm
                        email={email}
                        setEmail={setEmail}
                        isLoading={isAdminModalLoading}
                        setIsValid={setIsFormValid}
                    />
                </div>
                <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
                    <button
                        disabled={isAdminModalLoading || !isFormValid}
                        onClick={onAddBlockedEmailClicked}
                        className={`btn btn-secondary btn-sm mr-1 ${!isFormValid ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                    >
                        Add Blocked Email
                    </button>
                    <button onClick={onClose} className="btn btn-secondary btn-sm">
                        Cancel
                    </button>
                </div>
            </BaseModal>

            {errorAlertShown && (
                <div className="absolute top-0 w-full text-center transition-all">
                    <div role="alert" className="alert alert-error w-96 m-auto text-white">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 shrink-0 stroke-current"
                            fill="none"
                            viewBox="0 0 24 24"
                        ></svg>
                        <span>{errorMessage}</span>
                    </div>
                </div>
            )}

            {successAlertShown && (
                <div className="absolute top-0 w-full text-center transition-all">
                    <div role="alert" className="alert alert-success w-96 m-auto text-white">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 shrink-0 stroke-current"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                        <span>{successMessage}</span>
                    </div>
                </div>
            )}
        </>
    );
}

export { AddBlockedEmailModal };